import {FC, useState} from "react";
import {App, Button, Popconfirm, Table, TableProps, Tooltip} from "antd";
import {User} from "../../../../types/domain.ts";
import {DeleteOutlined, EditOutlined, LoginOutlined} from "@ant-design/icons";
import {EditUserModal} from "../EditUserModal/EditUserModal.tsx";
import {authReauthUserIdPost} from "../../../../api/auth/authReauthUserIdPost.ts";
import {useOwnProfile} from "../../../../stores/OwnProfileStore.ts";
import {authGet} from "../../../../api/auth/authGet.ts";
import {useNavigate} from "react-router";
import {UserWithContacts} from "../../../../components/UserWithContacts/UserWithContacts.tsx";
import {getUserOrigin} from "../../../../utils/getUserOrigin.ts";

type Props = {
    users: User[];
    loading: boolean;
    onUpdate: VoidFunction;
}

export const UsersTable: FC<Props> = ({ users, loading, onUpdate }) => {
    const [editingUser, setEditingUser] = useState<User>();

    const { profile, setProfile } = useOwnProfile();
    const { message } = App.useApp();
    const navigate = useNavigate();
    const handleRelogin = async (userId: number) => {
        try {
            await authReauthUserIdPost(userId);
            const u = await authGet();
            setProfile(u.payload);
            navigate('/');
            void message.success(`Теперь вы ${u.payload.first_name} ${u.payload.last_name}!`);
        } catch(e) {
            console.error(e);
            void message.error(JSON.stringify(userId));
        }
    }

    const columns: TableProps<User>['columns'] = [
        {
            key: 'id',
            dataIndex: 'id',
            title: 'CID'
        },
        {
            key: 'name',
            title: 'Имя',
            render: (_, user) => <UserWithContacts user={user} />
        },
        {
            key: 'role',
            title: 'Роль',
            render: (_, user) => getUserOrigin(user, true)
        },
        {
            key: 'edit',
            title: 'Редактировать',
            render: (_, user) => (
                <Button
                    icon={<EditOutlined />}
                    onClick={() => setEditingUser(user)}
                />
            )
        },
        {
            key: 'delete',
            title: 'Удалить',
            render: () => (
                <Tooltip title="Не реализовано">
                    <Button
                        danger
                        disabled
                        icon={<DeleteOutlined />}
                    />
                </Tooltip>
            )
        },
        ...(profile?.admin ? [{
            key: 'auth',
            title: 'Авторизоваться за',
            render: (_: unknown, { id, first_name, last_name }: User) => (
                <Popconfirm
                    title={`Переавторизоваться за ${first_name} ${last_name}?`}
                    onConfirm={() => handleRelogin(id)}
                >
                    <Button
                        icon={<LoginOutlined />}
                    />
                </Popconfirm>
            )
        }] : [])
    ]

    return (
        <>
            <Table
                columns={columns}
                dataSource={users}
                loading={loading}
                scroll={{ x: true }}
            />
            <EditUserModal
                user={editingUser}
                onClose={() => setEditingUser(undefined)}
                onEdit={onUpdate}
            />
        </>
    )
}